/**
 * created by lei lei on 2020/5/29
 * 活动排名组件
 */
import React, {Component} from 'react';
import ReactEcharts from 'echarts-for-react';
import {Radio} from "antd";
import {headers} from "../../../../actions";
let option = {
    title: {
        text: '单位：篇' ,//头部文字显示
            left: 50,
            top: 23,
            textStyle: {
            fontSize: '12',
                fontFamily: 'Microsoft YaHei'
        }
    },
    tooltip: {
        trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        }
    },
    legend: {
        left :100,
            data: ['已提交', '已完成', ]
    },
    grid: {
        left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
    },
    xAxis: {
        type: 'value',
            splitNumber: 2,
        /* scale: true,
         show:false,
         splitLine:{
             show:false
         }*/
    },
    yAxis: {
        offset:10 ,
        type: 'category',
            data: ['1', '2', '3', '4', '5', '6', '7']
    },
    series: [
        {
            name: '已提交',
            type: 'bar',
            stack: '总量',
            label: {
                show: true,
                position: 'insideRight',
                color:'#222226'
            },
            itemStyle : {
                normal : {
                    color:'#FFFEDE',
                    lineStyle:{
                        color:'#FFFEDE'
                    }
                }
            },
            data: [320, 302, 301, 334, 390, 330, 320]
        },
        {
            name: '已完成',
            type: 'bar',
            stack: '总量',
            label: {
                show: true,
                position: 'right',
                color:'#222226'
            },
            itemStyle : {
                normal : {
                    color:'#EAF8C3',
                    lineStyle:{
                        color:'#EAF8C3'
                    }
                }
            },
            data: [120, 132, 101, 134, 90, 230, 210]
        },

    ]
}
export default class ActivityRanking extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {

        super(props);
        this.state = {
            btnText:'本周',
            option : option,
            weekResults : JSON.parse(JSON.stringify(option)),
            dayResults : JSON.parse(JSON.stringify(option)),
            mounthResults : JSON.parse(JSON.stringify(option)),
        }
    }

    componentWillMount() {
    }

    componentDidMount()
    {
        getInterviewUserCountMap( (res)=>{
            if(res)
            {
                res.dayResults.reverse();
                res.mounthResults.reverse();
               // console.log("res.mounthResults:", res.mounthResults);
                res.weekResults.reverse();
                let that = this;
                this.state.dayResults.series[0].data = [];
                this.state.dayResults.series[1].data = [];
                this.state.dayResults.yAxis.data=[];
                res.dayResults.forEach(function(val){
                   // console.log(val._id,val.value.publish.day,val.value.over.day)
                    if(val.value.publish.day!==0||val.value.over.day!==0){
                        that.state.dayResults.yAxis.data.push(val._id);
                        if(val.value.publish.day===0){
                            that.state.dayResults.series[1].data.push(null);
                        }else{
                            that.state.dayResults.series[1].data.push(val.value.publish.day);
                        }
                        if(val.value.over.day===0){
                            that.state.dayResults.series[0].data.push(null);
                        }else{
                            that.state.dayResults.series[0].data.push(val.value.over.day);
                        }
                    }

                })
                this.state.mounthResults.series[0].data = [];
                this.state.mounthResults.series[1].data = [];
                this.state.mounthResults.yAxis.data=[];
                res.mounthResults.forEach(function(val){
                   // console.log(val._id,val.value.publish.mounthData,val.value.over.mounthData)
                    if(val.value.publish.mounthData!==0||val.value.over.mounthData!==0){
                        that.state.mounthResults.yAxis.data.push(val._id)
                        if(val.value.publish.mounthData===0){
                            that.state.mounthResults.series[1].data.push(null);
                        }else{
                            that.state.mounthResults.series[1].data.push(val.value.publish.mounthData);
                        }

                    if(val.value.over.mounthData===0){
                        that.state.mounthResults.series[0].data.push(null);
                    }else{
                        that.state.mounthResults.series[0].data.push(val.value.over.mounthData);
                    }
                    }



                })
                this.state.weekResults.series[0].data = [];
                this.state.weekResults.series[1].data = [];
                this.state.weekResults.yAxis.data=[];
                res.weekResults.forEach(function(val){
                    if(val.value.publish.week!==0||val.value.over.week!==0){
                        //console.log(val._id,val.value.publish.week,val.value.over.week)
                        that.state.weekResults.yAxis.data.push(val._id)
                        if(val.value.publish.week===0){
                            that.state.weekResults.series[1].data.push(null);
                        }else{
                            that.state.weekResults.series[1].data.push(val.value.publish.week);
                        }
                    if(val.value.over.week===0){
                        that.state.weekResults.series[0].data.push(null);
                    }else{
                        that.state.weekResults.series[0].data.push(val.value.over.week);
                    }
                    }
                })
               // console.log("that.state.mounthResults",that.state.mounthResults);
                this.setState({
                    option:this.state.weekResults
                })
            }
        });
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    handleSizeChange = e => {
        let data=e.target.value;

        if(data === "本周"){
            this.setState({option:this.state.weekResults})
        }else if(data === "本月"){
            this.setState({option:this.state.dayResults})
        }else if(data === "本年"){
            this.setState({option:this.state.mounthResults})
        }
        this.setState({ btnText: e.target.value });
    };

    render() {
        return (
            <div style={{position:'relative'}}>
                <div style={{height:300,width:'100%'}}>
                    <ReactEcharts
                        option={this.state.option}
                        notMerge={true}
                        lazyUpdate={true}
                        style={{width: '100%',height:'100%'}}
                    />
                </div>
                <div style={{height:32,width:250,position:'absolute',right:0,top:10}}>
                    <Radio.Group value={this.state.btnText} onChange={this.handleSizeChange}>
                        <Radio.Button value="本周">本周</Radio.Button>
                        <Radio.Button value="本月">本月</Radio.Button>
                        <Radio.Button value="本年">本年</Radio.Button>
                    </Radio.Group>
                </div>
            </div>
        )
    }
}

export const getInterviewUserCountMap = (callBack)=> {
    let url = "/cm-sites-pms/interview/getInterviewUserCountMap";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getInterviewUserCountMap",error);
        callBack("");
    })
}